import { Box, Collapse, Typography } from '@mui/material';
import * as React from 'react';
import { getDisclamers } from '@coverright/utils';

interface Props {
  open: boolean;
  maOrgCount?: string;
  maPlansCount?: string;
}

export function ConsentPanel({ open, maOrgCount, maPlansCount }: Props) {
  return (
    <Collapse in={open}>
      <Box
        sx={{
          border: '1px solid #cad5e2',
          bgcolor: '#FFF',
          p: 2,
          borderRadius: 2,
          overflowY: 'auto',
          maxHeight: 140,
          mt: 1.5,
        }}
      >
        <Typography variant={'caption'} color={'text.secondary'}>
          {getDisclamers('PERSONAL_INFO_ONBOARDING', { maOrgCount, maPlansCount } as any, 'Continue')}
        </Typography>
      </Box>
    </Collapse>
  );
}
